import React, { useState, useEffect } from "react";
import Api from "../../lib/componentApi";

const RecentInstagram = ({ restaurantUid, isMobile }) => {
  const [instagramData, setInstagramData] = useState(null);
  const loadMedia = () => {
    const limit = isMobile ? 9 : 12;
    Api.post(
      "/api/restaurant/instagram",
      {
        restaurantUid,
        page: 0,
        limit
      },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "code");
        } else {
          const data = response && (response.media || []);
          setInstagramData(data);
        }
      }
    );
  };
  useEffect(() => {
    if (!instagramData) {
      loadMedia();
    }
  }, [instagramData]);

  return (
    (instagramData && instagramData.length && (
      <div className="white-bg mt-10px title-box body instagram">
        <h5>Recent Instagram Photos</h5>
        <div className="row">
          {instagramData &&
            instagramData.map(media => {
              return (
                <div className="col-sm-3">
                  <a href={media.postUrl} target="_blank">
                    <span
                      style={{ backgroundImage: `url(${media.displayUrl})` }}
                    />
                  </a>
                </div>
              );
            })}
        </div>
      </div>
    )) || <noscript />
  );
};

export default RecentInstagram;
